/* eslint no-eval: 0 */
import React from "react";
//import moment from "moment"; // eslint-disable-line
import classnames from "classnames";
import FadeIn from "react-lazyload-fadein";
//import LazyLoad from "react-lazyload";
// import { CSSTransition, TransitionGroup } from "react-transition-group";
import PropTypes from "prop-types";

// Mui Components
import {
  MuiThemeProvider,
  createMuiTheme,
  withStyles
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
//import Grid from "@material-ui/core/Grid";
// import Paper from "@material-ui/core/Paper"; // eslint-disable-line
// import Button from "@material-ui/core/Button"; // eslint-disable-line
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent"; // eslint-disable-line
//import DialogContentText from "@material-ui/core/DialogContentText"; // eslint-disable-line
import Slide from "@material-ui/core/Slide";

// App Assets
import crestIcon from "../public/icons/oreidy-crest.svg";

const color = {
  maroon: "#6d242a",
  gold: "#cb8f60",
  light: "#cccccc",
  dark: "#555555",
  gallery: "#fff"
};

const displayFontFamily = "'Duke', sans-serif";
const bodyFontFamily = "'Aaux Pro', sans-serif";

const theme = createMuiTheme({
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: bodyFontFamily,
    fontSize: 18,
    display1: {
      fontSize: "1.8rem",
      fontFamily: bodyFontFamily,
      fontWeight: 500,
      marginBottom: "1.2rem"
    },
    display2: {
      fontFamily: bodyFontFamily,
      fontWeight: 500
    },
    display3: {
      fontFamily: bodyFontFamily,
      fontWeight: 500
    },
    display4: {
      fontFamily: displayFontFamily,
      fontWeight: 500
      // "@media (max-width:767px)": {
      //   fontSize: "6rem"
      // }
    },
    body1: {
      fontSize: "1.2rem",
      fontWeight: "normal",
      lineHeight: "1.46429em",
      color: "rgba(0, 0, 0, 0.87)"
    }
  }
});

const styles = theme => ({
  contentRoot: {
    display: "block",
    width: "100%",
    fontSize: 0
  },
  absolute: {
    position: "absolute",
    overflow: "hidden",
    zIndex: 0
  },
  fullWidth: {
    width: "100%"
  },
  container: {
    display: "block",
    width: "80%",
    maxWidth: "1200px",
    margin: "0 auto",
    "@media (max-width:1600px)": {
      width: "70%"
    },
    "@media (max-width:1200px)": {
      width: "80%"
    },
    "@media (max-width:1023px)": {
      width: "90%"
    },
    "@media (max-width:991px)": {
      width: "90%"
    },
    "@media (max-width:767px)": {
      width: "90%"
    }
  },
  content: {
    position: "relative",
    zIndex: 1
  },
  forename: {
    color: color.light,
    fontSize: "1.96rem",
    fontFamily: bodyFontFamily,
    fontWeight: 500,
    letterSpacing: "0.25rem",
    lineHeight: 1,
    marginLeft: "-4px"
  },
  surname: {
    color: color.gold,
    fontSize: "6rem",
    fontFamily: displayFontFamily,
    fontWeight: "normal",
    letterSpacing: "0.75rem",
    lineHeight: 1,
    marginTop: "-5px"
  },
  pronunciation: {
    marginLeft: "-7px"
  },
  surnameFix: {
    lineHeight: 1
  },
  crestContainer: {
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4
  },
  crest: {
    width: "100%",
    maxWidth: "600px",
    display: "block",
    margin: "0 auto"
  },
  crestVector: {
    width: "100px",
    height: "105px",
    display: "block",
    margin: "0 auto",
    marginBottom: theme.spacing.unit * 4
  },
  link: {
    textDecoration: "none",
    color: color.dark
  },
  textWhite: {
    color: "#fff"
  },
  textGold: {
    color: color.gold
  },
  textDark: {
    color: color.dark
  },
  backgroundMaroon: {
    backgroundColor: color.maroon
  },
  textCenter: {
    textAlign: "center"
  },
  section: {
    paddingTop: theme.spacing.unit * 8,
    paddingBottom: theme.spacing.unit * 8
  },
  sectionTop: {
    paddingTop: theme.spacing.unit * 8,
    paddingBottom: 0
  },
  sectionBottom: {
    paddingTop: 0,
    paddingBottom: theme.spacing.unit * 8
  },
  sectionSmall: {
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4
  },
  sectionLarge: {
    paddingTop: theme.spacing.unit * 12,
    paddingBottom: theme.spacing.unit * 12
  },
  eosMargin: {
    marginBottom: theme.spacing.unit * 8
  },
  buttonGroup: {
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  },
  question: {
    fontFamily: displayFontFamily,
    fontWeight: 900,
    fontSize: "2.5rem",
    lineHeight: "1.2em",
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    "@media (max-width:767px)": {
      fontSize: "2rem"
    }
  },
  answer: {
    fontFamily: bodyFontFamily,
    fontWeight: 400,
    fontSize: "1.5rem",
    lineHeight: "1.3em",
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 6,
    "@media (max-width:767px)": {
      fontSize: "1.25rem"
    }
  },
  imgBorderTop: {
    borderTop: theme.spacing.unit + "px solid " + color.gallery
  },
  imgBorderBottom: {
    borderBottom: theme.spacing.unit + "px solid " + color.gallery
  },
  imgBorderSides: {
    borderLeft: theme.spacing.unit + "px solid " + color.gallery,
    borderRight: theme.spacing.unit + "px solid " + color.gallery
  },
  imgColContainer: {
    width: "100%",
    boxSizing: "border-box",
    borderLeft: theme.spacing.unit + "px solid " + color.gallery,
    borderBottom: theme.spacing.unit + "px solid " + color.gallery,
    "@media (max-width:767px)": {
      borderBottom: 0
    }
  },
  imgCol4Container: {
    boxSizing: "border-box",
    borderLeft: theme.spacing.unit + "px solid " + color.gallery,
    borderRight: theme.spacing.unit + "px solid " + color.gallery,
    borderBottom: theme.spacing.unit + "px solid " + color.gallery,
    "@media (max-width:767px)": {
      borderBottom: 0,
      borderRight: 0
    }
  },
  imgCol1: {
    boxSizing: "border-box",
    width: "100%",
    margin: 0,
    borderLeft: theme.spacing.unit + "px solid " + color.gallery,
    borderRight: theme.spacing.unit + "px solid " + color.gallery,
    borderBottom: theme.spacing.unit + "px solid " + color.gallery
  },
  imgCol2: {
    display: "inline-block",
    boxSizing: "border-box",
    width: "50%",
    margin: 0,
    borderRight: theme.spacing.unit + "px solid " + color.gallery,
    "@media (max-width:767px)": {
      width: "100%",
      borderBottom: theme.spacing.unit + "px solid " + color.gallery
    }
  },
  imgCol3: {
    display: "inline-block",
    boxSizing: "border-box",
    width: "33.332%",
    margin: 0,
    borderRight: theme.spacing.unit + "px solid " + color.gallery,
    "@media (max-width:767px)": {
      width: "100%",
      borderBottom: theme.spacing.unit + "px solid " + color.gallery
    }
  },
  imgCol4: {
    display: "inline-block",
    boxSizing: "border-box",
    width: "25%",
    margin: 0,
    borderRight: theme.spacing.unit + "px solid " + color.gallery,
    "@media (max-width:767px)": {
      width: "50%",
      borderBottom: theme.spacing.unit + "px solid " + color.gallery
    }
  },
  imgColLast: {
    borderRight: 0
  },
  scrollText: {
    color: color.dark,
    fontSize: "1.2rem",
    textShadow: "0 1px 6px rgba(0,0,0,0.5)",
    fontWeight: 600
  },
  scrollArrow: {
    fill: color.dark,
    width: "36px",
    height: "36px"
  },
  button: {
    padding: theme.spacing.unit * 2
  }
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function ImgLoader(props) {
  const {
    imgsrc,
    imgClass,
    hasInfo = false,
    click = null,
    width = 2600,
    altText = "Spencer and Lani Jackson Hole Wedding",
    bgColor = "#eee"
  } = props;

  return (
    <div className={imgClass} style={{ backgroundColor: bgColor }}>
      <FadeIn height={600}>
        {onload => {
          if (hasInfo) {
            return (
              <div style={{ position: "relative" }}>
                <picture style={{ width: "100%" }} onLoad={onload}>
                  <source
                    type="image/webp"
                    media="(max-width: 575px)"
                    srcset={`/image/f=webp&w=600/${imgsrc} 1x, /image/f=webp&w=1200/${imgsrc} 2x`}
                  />
                  <source
                    type="image/webp"
                    media="(max-width: 767px)"
                    srcset={`/image/f=webp&w=800/${imgsrc} 1x, /image/f=webp&w=1600/${imgsrc} 2x`}
                  />
                  <source
                    type="image/webp"
                    media="(max-width: 991px)"
                    srcset={`/image/f=webp&w=1000/${imgsrc} 1x, /image/f=webp&w=2000/${imgsrc} 2x`}
                  />
                  <source
                    type="image/webp"
                    srcset={`/image/f=webp&w=${width}/${imgsrc} 1x, /image/f=webp&w=${width *
                      1.5}/${imgsrc} 1.5x, /image/f=webp&w=${width *
                      2}/${imgsrc} 2x`}
                  />
                  <source
                    type="image/jpeg"
                    media="(max-width: 575px)"
                    srcset={`/image/f=jpeg&w=600/${imgsrc} 1x, /image/f=jpeg&w=1200/${imgsrc} 2x`}
                  />
                  <source
                    type="image/jpeg"
                    media="(max-width: 767px)"
                    srcset={`/image/f=jpeg&w=800/${imgsrc} 1x, /image/f=jpeg&w=1600/${imgsrc} 2x`}
                  />
                  <source
                    type="image/jpeg"
                    media="(max-width: 991px)"
                    srcset={`/image/f=jpeg&w=1000/${imgsrc} 1x, /image/f=jpeg&w=2000/${imgsrc} 2x`}
                  />
                  <source
                    type="image/jpeg"
                    srcset={`/image/f=jpeg&w=${width}/${imgsrc} 1x, /image/f=webp&w=${width *
                      1.5}/${imgsrc} 1.5x, /image/f=jpeg&w=${width *
                      2}/${imgsrc} 2x`}
                  />
                  <img
                    src={`/image/f=jpeg&w=${width * 2}/${imgsrc}`}
                    style={{ width: "100%" }}
                    alt={altText}
                  />
                </picture>
                <IconButton
                  aria-label="Info"
                  style={{ position: "absolute", bottom: "4px", left: "4px" }}
                  onClick={click}
                >
                  <InfoIcon />
                </IconButton>
              </div>
            );
          } else {
            return (
              <picture style={{ width: "100%" }} onLoad={onload}>
                <source
                  type="image/webp"
                  media="(max-width: 575px)"
                  srcset={`/image/f=webp&w=600/${imgsrc} 1x, /image/f=webp&w=1200/${imgsrc} 2x`}
                />
                <source
                  type="image/webp"
                  media="(max-width: 767px)"
                  srcset={`/image/f=webp&w=800/${imgsrc} 1x, /image/f=webp&w=1600/${imgsrc} 2x`}
                />
                <source
                  type="image/webp"
                  media="(max-width: 991px)"
                  srcset={`/image/f=webp&w=1000/${imgsrc} 1x, /image/f=webp&w=2000/${imgsrc} 2x`}
                />
                <source
                  type="image/webp"
                  srcset={`/image/f=webp&w=${width}/${imgsrc} 1x, /image/f=webp&w=${width *
                    1.5}/${imgsrc} 1.5x, /image/f=webp&w=${width *
                    2}/${imgsrc} 2x`}
                />
                <source
                  type="image/jpeg"
                  media="(max-width: 575px)"
                  srcset={`/image/f=jpeg&w=600/${imgsrc} 1x, /image/f=jpeg&w=1200/${imgsrc} 2x`}
                />
                <source
                  type="image/jpeg"
                  media="(max-width: 767px)"
                  srcset={`/image/f=jpeg&w=800/${imgsrc} 1x, /image/f=jpeg&w=1600/${imgsrc} 2x`}
                />
                <source
                  type="image/jpeg"
                  media="(max-width: 991px)"
                  srcset={`/image/f=jpeg&w=1000/${imgsrc} 1x, /image/f=jpeg&w=2000/${imgsrc} 2x`}
                />
                <source
                  type="image/jpeg"
                  srcset={`/image/f=jpeg&w=${width}/${imgsrc} 1x, /image/f=webp&w=${width *
                    1.5}/${imgsrc} 1.5x, /image/f=jpeg&w=${width *
                    2}/${imgsrc} 2x`}
                />
                <img
                  src={`/image/f=jpeg&w=${width * 2}/${imgsrc}`}
                  style={{ width: "100%" }}
                  alt={altText}
                />
              </picture>
            );
          }
        }}
      </FadeIn>
    </div>
  );
}

class Home extends React.Component {
  state = {
    dialogOpen: false,
    dialogTitle: "",
    dialogDescription: "",
    tabIndex: 0,
    grow: true
  };

  static contextTypes = {
    parallaxController: PropTypes.object.isRequired
  };

  handleTabChange = (event, tabIndex) => {
    let page = "pricing";

    switch (tabIndex) {
      case 1:
        page = "info";
        break;
      case 2:
        page = "related";
        break;
      case 3:
        page = "notes";
        break;
      case 0:
      default:
        page = "pricing";
        break;
    }
    this.setState({ tabIndex });
    this.props.history.push(this.props.match.url + "/" + page);
  };

  handleChange = name => e => {
    this.setState({
      [name]: e.target.value
    });
  };

  handleClickOpen = msg => {
    this.setState({ dialogOpen: true, dialogMsg: msg });
  };

  handleDialogOpen = dc => {
    this.setState({
      dialogOpen: true,
      dialogTitle: dc.title,
      dialogDescription: dc.description
    });
  };

  handleClose = () => {
    this.setState({
      dialogOpen: false
    });
    setTimeout(
      this.setState({
        dialogTitle: "",
        dialogDescription: ""
      }),
      1000
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.contentRoot}>
          <div className={classnames(classes.textCenter, classes.section)}>
            <div>
              <Typography className={classes.forename}>
                Spencer & Lani
              </Typography>
              <Typography className={classes.surname}>O'REIDY</Typography>
              <Typography
                className={classnames(classes.pronunciation, classes.textGold)}
              >
                [ oh • RYE (like whiskey) • dee ]
              </Typography>
            </div>
          </div>
          <div className={classes.crestContainer}>
            <ImgLoader
              imgsrc="images/assets/oreidy-crest.jpg"
              imgClass={classes.crest}
              bgColor="#fff"
            />
          </div>
          <div
            className={classnames(
              classes.container,
              classes.section,
              classes.textCenter
            )}
          >
            <Typography variant="display1" className={classes.textGold}>
              Spencer Ready and Lani Gunderson are now Mr. & Mrs. O’Reidy
            </Typography>
            <Typography variant="body1">
              John Spencer O’Reidy and Lani Taylor Gunderson were married on
              September 23, 2018 at 4:00pm at String Lake in Grand Teton
              National Park. In attendance was our officiant, Hamish Tear, our
              photographer, Taylor Glenn, his assistant, Brantley Sydnor, and
              assorted wildlife (mostly squirrels).
            </Typography>
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0077.jpg"
            imgClass={classes.fullWidth}
          />
          <div className={classes.backgroundMaroon}>
            <div
              className={classnames(
                classes.container,
                classes.section,
                classes.textCenter
              )}
            >
              <Typography variant="display1" className={classes.textWhite}>
                Wait, what’s up with the name change?
              </Typography>
              <Typography
                variant="body1"
                className={classnames(classes.textGold, classes.eosMargin)}
              >
                O’Reidy was an original form of the Ready family name. Spencer
                figured he’d restore some of the pre-Anglicized, Irish family
                history and spare Lani a life of introducing herself with a name
                containing three consecutive “ee” syllables. We’re our own
                support group for dealing with spending too much time in
                government agencies for name changes.
              </Typography>
              <div className={classes.crestVector}>
                <img src={crestIcon} alt="O'Reidy Crest" />
              </div>
              <Typography variant="display1" className={classes.textWhite}>
                And, what’s with the bird...or birds?
              </Typography>
              <Typography variant="body1" className={classes.textGold}>
                It’s a double-headed eagle, the family crest of the O’Reidy
                clan. Spencer worked with Travis Ladue to re-imagine a modern
                interpretation of the crest, which is traditionally symbolic of
                wisdom and speed.
              </Typography>
            </div>
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0001.jpg"
            imgClass={classes.fullWidth}
          />
          <div
            className={classnames(
              classes.container,
              classes.section,
              classes.textCenter
            )}
          >
            <Typography variant="display1" className={classes.textGold}>
              So, how was the wedding?
            </Typography>
            <Typography variant="body1" className={classes.eosMargin}>
              It was everything we wanted. It was intimate, natural, and
              succinct. We prepared a ceremony that was delivered wonderfully by
              our officiant, and we each wrote and recited our own vows. There
              was very little fanfare, and everything that needed to be said
              between us was done in under ten minutes. It was an experience
              that we'll cherish and never forget.
            </Typography>
            <Typography variant="display1" className={classes.textGold}>
              How was Jackson Hole?
            </Typography>
            <Typography variant="body1" className={classes.eosMargin}>
              Fantastic. Absolutely loved it. The surroundings were absolutely
              stunning. Our modern cabin (which we definitely recommend) at the
              Fireside Resort was cozy and comfortable, especially after a day
              of hiking. And the hiking was wonderful. Once we got used to the
              altitude...okay we never fully adjusted...but we still loved it
              despite the more than 5000 ft. increase in altitude compared to
              home. We saw wildlife, an abundance of nature, and all sorts of
              weather. And we can’t do a proper recap of the trip without
              complimenting the food, which was varied and delicious. Shout out
              in particular to Persephone Bakery, where we ate three mornings in
              a row because the first meal was so good; and Glorietta’s, who
              brought us champagne on the house when they found out we’d just
              been married.
            </Typography>
            <Typography variant="display1" className={classes.textGold}>
              Can we see some more pictures now?
            </Typography>
            <Typography variant="body1">
              Sure. (best viewed on a large screen)
            </Typography>
          </div>
          <div
            className={classnames(
              classes.imgBorderTop,
              classes.imgColContainer
            )}
          >
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-21_015.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-21_023.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0046.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-21_037.jpg"
              imgClass={classes.imgCol2}
              width={1300}
              hasInfo={true}
              click={() =>
                this.handleDialogOpen({
                  title: "Legal",
                  description:
                    "This was were we sorted out our marriage license. They had a whole wall of physical record books for the county. Pretty neat. (They're digital now, but they've kept the books)"
                })
              }
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_067.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0071.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/LaniSpencer-0218.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/LaniSpencer-0076.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/hm_2018-09-21_052.jpg"
            imgClass={classes.imgCol1}
          />
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0129.jpg"
            imgClass={classes.imgCol1}
          />
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0168.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-21_041.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-21_057.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>

          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0235.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_074.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_069.jpg"
              imgClass={classes.imgCol2}
              width={1300}
              hasInfo={true}
              click={() =>
                this.handleDialogOpen({
                  title: "Delicious.",
                  description:
                    "One of several breakfasts that we ate at Persephone Bakery. Seriously, this place was the best."
                })
              }
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0269.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-21_050.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-24_300.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0146.jpg"
            imgClass={classes.imgCol1}
          />
          <ImgLoader
            imgsrc="images/jackson-hole/hm_2018-09-21_051.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-24_141.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-24_142.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0159.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_077.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_095.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>

          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_088.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_104.jpg"
              imgClass={classes.imgCol2}
              width={1300}
              hasInfo={true}
              click={() =>
                this.handleDialogOpen({
                  title: "Branding",
                  description:
                    "Loved this large badge on the signage for the Jackson Lake Dam and Reservoir."
                })
              }
            />
          </div>
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_101.jpg"
              imgClass={classes.imgCol2}
              width={1300}
              hasInfo={true}
              click={() =>
                this.handleDialogOpen({
                  title: "Jackson Lake Dam and Reservoir",
                  description: "Four gates open."
                })
              }
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_114.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0321.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_122.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-22_124.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0339.jpg"
            imgClass={classes.imgCol1}
          />
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0352.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-24_158.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-24_169.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>

          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-24_172.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-24_182.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0369.jpg"
            imgClass={classes.imgCol1}
          />
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0380.jpg"
            imgClass={classes.imgCol1}
          />
          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-25_196.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-25_198.jpg"
              imgClass={classes.imgCol2}
              width={1300}
              hasInfo={true}
              click={() =>
                this.handleDialogOpen({
                  title: "Abode & Transport",
                  description:
                    "This is the cabin where we stayed; Fireside Resort. Also pictured: the Golf GTI we rented through Turo to get around while were were there."
                })
              }
            />
          </div>

          <div className={classes.imgColContainer}>
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-24_187.jpg"
              imgClass={classes.imgCol2}
              width={1300}
            />
            <ImgLoader
              imgsrc="images/jackson-hole/hm_2018-09-25_206.jpg"
              imgClass={classes.imgCol2}
              width={1300}
              hasInfo={true}
              click={() =>
                this.handleDialogOpen({
                  title: "Author note:",
                  description:
                    "Lani dislikes that I included this photo. I think it's adorable."
                })
              }
            />
          </div>
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0387.jpg"
            imgClass={classes.imgCol1}
          />
          <ImgLoader
            imgsrc="images/jackson-hole/LaniSpencer-0394.jpg"
            imgClass={classes.imgCol1}
          />
        </div>
        <div
          className={classnames(
            classes.container,
            classes.section,
            classes.textCenter
          )}
        >
          <Typography variant="display1" className={classes.textGold}>
            Do you have more photos?
          </Typography>
          <Typography variant="body1" className={classes.eosMargin}>
            Sure do (over 400 just from our photographer). But Spencer has other
            work to be getting on with besides this site, and we just wanted to
            share some of the highlights. Happy to share more in person, if
            you're interested. Thanks for having a look, and much love to you
            all.
          </Typography>
        </div>

        <Dialog
          open={this.state.dialogOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent className={classnames(classes.bckgDark)}>
            <Typography variant="display1" className={classes.textGold}>
              {this.state.dialogTitle}
            </Typography>
            <Typography variant="body1">
              {this.state.dialogDescription}
            </Typography>
            {/* <DialogContentText id="alert-dialog-slide-description">
            </DialogContentText> */}
          </DialogContent>
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(Home);



// WEBPACK FOOTER //
// ./src/views/Home.js